import JsonLd from "./JsonLd";

/**
 * LodgingBusiness schema with AggregateRating + reviews — gives SEO landing
 * pages star ratings in Google search results. Same business data as HomePage.
 */
const SAVI_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "@id": "https://www.savicoliving.com/#business",
  name: "Savi Coliving",
  alternateName: "Savi",
  slogan: "A clear mind, in good company.",
  description:
    "Europe's award-winning sober coliving. Best for alcohol-free living, deep work and long stays in the mountains near Valencia. A 16-room villa in the Sierra Calderona, 25 minutes from Valencia, Spain: pool, gym, yoga studio, coworking, shared dinners. Alcohol and drug free for guests and staff. Opened July 2025. Application only, stays of a month or more.",
  url: "https://www.savicoliving.com",
  telephone: "+34632628051",
  email: "hola@savicoliving.com",
  foundingDate: "2025-07",
  numberOfRooms: 16,
  petsAllowed: true,
  checkinTime: "15:00",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Sierra Calderona",
    addressLocality: "Náquera",
    postalCode: "46119",
    addressRegion: "Valencia",
    addressCountry: "ES",
  },
  geo: { "@type": "GeoCoordinates", latitude: 39.6667, longitude: -0.4167 },
  priceRange: "€1,200 - €2,100/month",
  image: "https://static.wixstatic.com/media/447ef7_c4f040f251774723aaf22ea2f5874e83~mv2.jpg",
  founder: { "@type": "Person", name: "Steve Haynes", url: "https://www.linkedin.com/in/stevehaynes-savi", sameAs: ["https://thecolivingadvisor.com"] },
  award: [
    "Winner – Best Destination Coliving, Coliving Awards 2026",
    "Winner – Worldpackers SDG Award 2025",
  ],
  knowsAbout: ["sober coliving", "alcohol-free travel", "coliving in Valencia", "remote work communities", "intentional living"],
  amenityFeature: [
    { "@type": "LocationFeatureSpecification", name: "Alcohol-free environment", value: true },
    { "@type": "LocationFeatureSpecification", name: "Swimming Pool", value: true },
    { "@type": "LocationFeatureSpecification", name: "Gym", value: true },
    { "@type": "LocationFeatureSpecification", name: "Yoga Studio", value: true },
    { "@type": "LocationFeatureSpecification", name: "Coworking Space", value: true },
    { "@type": "LocationFeatureSpecification", name: "Starlink WiFi", value: true },
    { "@type": "LocationFeatureSpecification", name: "Roof Terrace", value: true },
    { "@type": "LocationFeatureSpecification", name: "Shared dinners", value: true },
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    bestRating: "5",
    reviewCount: "3",
  },
  review: [
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Travis Weeks" },
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody:
        "A rare environment where you can slow down, connect, and leave clearer, more focused, and recharged than when you arrived. When I'm back in Spain, this is where I'll come home to.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Saskia Rehhahn" },
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody:
        "I've come across many co-working and co-living spaces through my work — Savi, with its sober concept, is truly something very special. A place that leaves a lasting impression.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Devinn" },
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody:
        "I genuinely couldn't have found a better co-living spot in Valencia. The location is incredible. The community is warm. The standard of hosting is on another level.",
    },
  ],
  brand: [{ "@type": "Brand", name: "Savi Sojourns", url: "https://www.savicoliving.com/sojourns", sameAs: "https://savisojourns.com", description: "A month-long, alcohol-free business and wellness retreat for twelve business owners, with three business mentors. Spring 2027, by application." }],
  sameAs: [
    "https://savisojourns.com",
    "https://www.instagram.com/savicoliving/",
    "https://www.linkedin.com/company/savi-coliving",
    "https://www.facebook.com/profile.php?id=61577166869338",
    "https://share.google/vAiTkEUZOQ3c4GfKE",
    "https://wa.me/34632628051",
  ],
};

const SaviBusinessJsonLd = ({ id }) => <JsonLd id={`business-${id}`} data={SAVI_BUSINESS} />;

export default SaviBusinessJsonLd;
